// extracted by mini-css-extract-plugin
export default {"companyContainer":"NP-z","companyImage":"OP-z","container":"PP-z","heading":"QP-z","darkText":"RP-z","smallHeading":"SP-z","darkBackground":"TP-z","whiteBackground":"UP-z"};